import React, { useState, useEffect, useMemo } from 'react';
import { InitialRender } from '../../common/Helper';
import { Link, useParams } from 'react-router-dom';
import DataTableComponent from "../../common/DataTableComponent";
import {
  IMAGE_URL,
  TABLE_DATE_FORMAT,
  TABLE_TIME_FORMAT,
} from '../../../utils/Constants';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import { handleTableScroll } from "../../../utils/commonFunction";
import {
  DeleteStudentRegistration,
  GetReRegStudentListFiltersCancelToken,
  GetStudentListBasedOnReregistrationCancelToken,
  ReRegisterStudent,
  programmeReRegisterSubmitStatus,
} from '../../../services/RegistrationService';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { RegStudentColorComb } from '../../systemadministration/usermanagement/CheckRole';
import Hover from '../../common/Hover';
import {
  RenderLateReReg,
  RenderReason,
  RenderRegistrationStatus,
} from '../../../utils/CommonStatusItems';
import Swal from 'sweetalert2';
import PermissionsGate from '../../../utils/permissionGate';
import $ from 'jquery';
import axios from 'axios';
import { createCleanFilePath } from '../../../utils/FileDownload';

const StudentList = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [studentListStatus, setStudentListStatus] = useState([]);
  const [intake, setIntake] = useState({ arr: [], checkObj: {} });
  const [reason, setReason] = useState({ arr: [], checkObj: {} });
  const [status, setStatus] = useState({ arr: [], checkObj: {} });
  const [salesRep, setSalesRep] = useState({ arr: [], checkObj: {} });
  const [lateReg, setLateReg] = useState({ arr: [], checkObj: {} });
  const [showCkEditor, setShowCkEditor] = useState(false);
  const [studentID, setStudentID] = useState('');
  const [contactedNotes, setContactedNotes] = useState('');
  const [ContactLoading, setContactLoading] = useState(false);
  const [AddLoading, setAddLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [tableState, setTableState] = useState({
    page: 1,
    perPage: 10,
    sortKey: "created_date",
    sortOrder: "DESC",
  });
  
  const [filterData, setFilterData] = useState({
    intake: [],
    reason: [],
    status: [],
    salesRep: [],
    lateReReg: []
  });
  const [deleteRow, setDeleteRow] = useState(false);
  
  const handleConatactedStudent = () => {
    setContactLoading(true);
    let data = {
      registration_id: id,
      status: studentID?.registration_status?.includes('Contacted')
      ? studentID?.registration_status
      : studentID?.registration_status + ' - Contacted',
      notes: contactedNotes,
      student_id: studentID?.student,
    };
    programmeReRegisterSubmitStatus(data)
    .then((res) => {
      setContactLoading(false);
      if (res.status === 200) {
        $('#feature-popup').modal('hide');
        setShowCkEditor(false);
        setStudentID('');
        setContactedNotes('');
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: res.data.message,
          onClose: () => {
            setDeleteRow(!deleteRow);
            //reload page
            window.location.reload();
          },
        });
      }
    })
    .catch((err) => {
      setContactLoading(false);
      console.log(err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${err?.response?.data?.data}`,
      });
    });
  };
  useEffect(() => {
    handleTableScroll()
  }, [loading])
  
  useEffect(() => {
    const storedFilters = JSON.parse(localStorage.getItem("filterStateReRegistrationStudents"));
    if (storedFilters) {
      setIntake(storedFilters.intake);
      setReason(storedFilters.reason);
      setStatus(storedFilters.status);
      setSalesRep(storedFilters.salesRep);
    }
  }, []);
  
  useEffect(() => {
    const filterState = {
      intake,
      reason,
      status,
      salesRep,
      lateReg
    };
    localStorage.setItem("filterStateReRegistrationStudents", JSON.stringify(filterState));
  }, [  intake, reason, status, salesRep, lateReg ]);
  
  useEffect(() => {
    const source = axios.CancelToken.source();
    const getListData = async () => {
      setLoading(true);
      try {
        let data ={
          id: id,
          totalRows: totalRows,
          perPage: tableState.perPage,
          page: tableState.page,
          sortkey: tableState.sortKey,
          sortOrder: tableState.sortOrder,
          debouncedTerm: debouncedTerm,
          intake: intake,
          reason: reason,
          status: status,
          salesRep: salesRep,
          lateReg: lateReg
        }
        const res = await GetStudentListBasedOnReregistrationCancelToken(
          data,
          source.token
        );
        if (res.status == 200) {
          setStudentListStatus(
            res && res.data && res.data.qualication ? res.data.qualication : []
          );
          setTotalRows(res.data?.pagination?.total ? res.data?.pagination?.total : 0);
          setLoading(false);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setLoading(false);
        }
      }
    };
    getListData();
    
    return () => {
      source.cancel('Component unmounted');
    };
  }, [id, deleteRow, debouncedTerm, intake, reason,status, salesRep, lateReg, tableState]);
  
  useEffect(() => {
    const dropdownSource = axios.CancelToken.source();
    
    const fetchData = async () => {
      try {
        const res = await GetReRegStudentListFiltersCancelToken(
          id,
          dropdownSource.token
        );
        
        if (res.status === 200) {
          setFilterData({
            intake: res.data.intakeFilter,
            reason: res.data.reasonFilter,
            status: res.data.statusFilter,
            salesRep: res?.data.salesPersonFilter,
            lateReReg: res?.data.lateReRegFilter
          });
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };
    
    fetchData();
    
    return () => {
      dropdownSource.cancel('Component unmounted');
    };
  }, [deleteRow]);
  
  const handleAddRegistration = (data) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will create a new re-registration!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        setAddLoading(true);
        const sendData = {
          reregistration_id: id,
          student_id: data.student,
          early_bird_discount:
          data.early_bird_end_date >
          moment().unix()
          ? 'Yes'
          : 'No',
        };
        ReRegisterStudent(sendData)
        .then((res) => {
          setAddLoading(false);
          if (res.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: res.data.message,
              onClose: () => {
                setDeleteRow(!deleteRow);
                var RegID = res?.data?.register;               
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: `${err?.response?.data?.data}`,
          });
        });
      }
    });
  };
  
  const handleDeleteRegistration = (data) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this registration!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        const parameter = { uid: data.registration_id };
        DeleteStudentRegistration(parameter)
        .then((res) => {
          if (res.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: res.data.message,
              onClose: () => {
                setDeleteRow(!deleteRow);
                window.location.reload();
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: `${err?.response?.data?.data}`,
          });
        });
      }
    });
  };
  
  const columns = useMemo(() => [
    {
      name: 'Student',
      selector: 'student_name',
      sortField: 'first_name',
      sortable: true,
      cell: (row) => (
        <div className="assigned-title-block-new">
          <div className="assigned-title-itm">
            <span className={'assigned-title-blk  name-icon cat-dark-red '}>
              {row?.photo ? (
                <img
                  src={`${IMAGE_URL}/${createCleanFilePath(row?.photo)}`}
                  alt="AIE"
                />
              ) : (
                InitialRender([
                  row.student_name.split(' ')[0],
                  row.student_name.split(' ').reverse()[0],
                ])
              )}
              <span
                className={`profile-box-2-status ${
                  row.activity_status
                    ? row.activity_status.toLowerCase() == 'online'
                      ? 'Online'
                      : row.activity_status.toLowerCase() == 'away'
                      ? 'Away'
                      : 'Offline'
                    : 'Offline'
                }`}
              >
                <i className="fas fa-circle"></i>
              </span>
              <Hover
                firstName={row.student_name.split(' ')[0]}
                lastName={row.student_name.split(' ').reverse()[0]}
                photo={row.photo}
                email={row.email}
                mobile={row.mobile}
                right={true}
                role="Sales"
                status={row.status}
                activity_status={row.activity_status}
                showNumber={true}
                number={row.student_crm_id}
              />
            </span>
          {row.registration_id && row.registration_status !="Declined - Contacted" && row.registration_status !="Not Yet Registered - Contacted" && row.registration_status != "Declined" && row.registration_status != "Not Yet Registered" ? (
              <Link
                to={`/studentadministration/registration/open/registration?studentId=${row.registration_id}&studentName=${row.student_name}`}
                className="as-text-blue curser"
            ><span className="textLimit100">{row.student_name}</span></Link>
          )
          : (
              <Link 
                to={`/studentAdministration/students/open/${row.student}/general`}
                className="as-text-blue curser"
            ><span className="textLimit100">{row.student_name}</span></Link>)} 
          </div>
        </div>
      ),
    },
    {
      name: 'Re-registration Status',
      selector: 'registration_status',
      sortField: 'registration_status',
      sortable: true,
      cell: (row) =>
        row.registration_status ? (
          <span title={row.registration_status}>
            {RenderRegistrationStatus(row.registration_status).html}
            {row.notes ? (
              <p className="decline-reason-comment" title={row?.notes}>
                {row.notes}
              </p>
            ) : null}
          </span>
        ) : (
          '-'
        ),
    },
    {
      name: 'Decline Reason',
      selector: 'not_submit_reason',
      sortField: 'not_submit_reason',
      sortable: true,
      cell: (row) => {
        if (row.not_submit_reason && filterData.reason.length) {
          const rowReason = filterData.reason.find(
            (item) => item.value == row.not_submit_reason
          );
          return (
            <span title={row.not_submit_reason_description}>
              {RenderReason(rowReason.label, rowReason.color).html}
              {row.not_submit_reason_description ? (
                <p className="decline-reason-comment">
                  {row.not_submit_reason_description}
                </p>
              ) : null}
            </span>
          );
        } else {
          return 'N/A';
        }
      },
    },
    {
      name: 'Student No.',
      selector: 'student_number',
      sortField: 'student_number',
      sortable: true,
      cell: (row) =>
        row.student_number ? (
          <span className="feature-name">
            <span className="textLimit100">{row.student_number}</span>
          </span>
        ) : (
          '-'
        ),
    },
    {
      name: 'Student ID',
      selector: 'student_id',
      sortField: 'student_id',
      sortable: false,
      cell: (row) =>
        row.student_id ? (
          <span className="feature-name">
            <span className="textLimit100">{row.student_id}</span>
          </span>
        ) : (
          '-'
        ),
    },
    {
      name: 'Programme',
      selector: 'qualification_name',
      sortField: 'qualification_name',
      sortable: true,
      cell: (row) => (
        <span className="overflow-ellipsis2 fst_line2">
          <Link
            to={`/courseAdministration/Programmes/programme/open/${row.qualification_id}/details`}
            className="as-text-blue curser"
            title={row.qualification_name ? row.qualification_name : ''}
          >
            {row.qualification_name ? row.qualification_name : '-'}
          </Link>
        </span>
      ),
    },
    {
      name: 'Intake',
      selector: 'intake_year',
      sortField: 'intake_year',
      sortable: true,
      cell: (row) => row.intake_year + '-' + row.intake_number,
    },
    {
      name: 'Date',
      selector: 'created_date',
      sortField: 'created_date',
      sortable: true,
      cell: (row) => (
        <>
          {row.created_date ? (
            <div className="dateTime">
              <p className="right-space">
                {moment.unix(row.created_date).format(TABLE_DATE_FORMAT)}
              </p>
              <p>{moment.unix(row.created_date).format(TABLE_TIME_FORMAT)}</p>
            </div>
          ) : (
            '-'
          )}
        </>
      ),
    },
    {
      name: 'Status',
      selector: 'status',
      sortField: 'status',
      sortable: true,
      cell: (row) => {
        return row.status ? RegStudentColorComb(row.status.toLowerCase()) : '-';
      },
    },
    {
      name: 'Sales Rep.',
      selector: 'sale_person_first_name',
      sortable: true,
      sortField: 'sale_person_first_name',
      cell: (row) =>
        row?.sale_person_first_name ? (
          <div className="assigned-title-block-new">
            <div className="assigned-title-itm">
              <span className={'assigned-title-blk  name-icon cat-dark-red '}>
                {row?.sale_person_photo ? (
                  <img
                    src={`${IMAGE_URL}/${createCleanFilePath(row?.sale_person_photo)}`}
                    alt="AIE"
                  />
                ) : (
                  InitialRender([
                    row.sale_person_first_name,
                    row.sale_person_last_name,
                  ])
                )}
                <span
                  className={`profile-box-2-status ${
                    row.sale_person_activity_status
                      ? row.sale_person_activity_status.toLowerCase() ==
                        'online'
                        ? 'Online'
                        : row.sale_person_activity_status.toLowerCase() ==
                          'away'
                        ? 'Away'
                        : 'Offline'
                      : 'Offline'
                  }`}
                >
                  <i className="fas fa-circle"></i>
                </span>
                <Hover
                  firstName={row.sale_person_first_name}
                  lastName={row.sale_person_last_name}
                  photo={row.sale_person_photo}
                  email={row.sale_person_email}
                  mobile={row.sale_person_mobile}
                  role="Sales"
                  activity_status={row.sale_person_activity_status}
                  showNumber={true}
                />
              </span>
              <Link
                to={`/systemAdministration/userManagement/open/${row.sale_person_id}/aboutYou`}
                className="as-text-blue curser"
              >
                <span className="textLimit100">
                  {row?.sale_person_first_name +
                    ' ' +
                    row?.sale_person_last_name}
                </span>
              </Link>
            </div>
          </div>
        ) : (
          '-'
        ),
    },
    {
      name: 'Late Re-Reg',
      selector: 'late_re_reg',
      sortable: true,
      cell: (row) => (
        <div className="custom-control custom-checkbox text-left table-curser" title="Late Re-Reg">
          <input
            type="checkbox"
            readOnly
            className="custom-control-input"
            id={`late_re_reg${row?.id}`}
            name="late_re_reg"
                checked={row.late_re_reg==1}         
          />
                <label className="custom-control-label" htmlFor={row?.id}></label>
        </div>
      ),
    },
    {
      name: 'Action',
      selector: 'Action',
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons d-flex">
                {row.registration_id && row.registration_status !="Declined - Contacted" && row.registration_status !="Not Yet Registered - Contacted" && row.registration_status != "Declined" && row.registration_status != "Not Yet Registered" ? (
                  
                  <PermissionsGate scopes={["regview"]} errorProps={{ disabled: true }}><Link
                  title="Open"                
                  className="btn btn-primary rounded-circle"
                  to={`/studentadministration/registration/open/registration?studentId=${row.registration_id}&studentName=${row.student_name}`}
                  ><i className="fal fa-folder-open"></i></Link></PermissionsGate>
                )
                : (
              <PermissionsGate scopes={["sview"]} errorProps={{ disabled: true }}>
                <Link 
                  title="Open"                
                  className="btn btn-primary rounded-circle disabled"to={`/studentAdministration/students/open/${row.student}/general`}
                  ><i className="fal fa-folder-open disabled"></i></Link>
                  </PermissionsGate>)} 
            {row.registration_status == 'Not Yet Registered' ||
              row.registration_status == 'Declined' ||
              row.registration_status == "Declined - Contacted"  ||
              row.registration_status == "Not Yet Registered - Contacted" ? (
                <div className="as-buttons dropdown btn-dropdown-item">
                      
                      
                  <button
                    className="btn btn-primary rounded-circle dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    title="More"
                    disabled={AddLoading}
                  >
                    {AddLoading ? (
                      <i className="fas fa-cog fa-spin"></i>
                    ) : (
                      <i className="fal fa-ellipsis-h-alt"></i>
                    )}
                      
                  </button>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                      {row.reregistration_id && row.reregistration_id != '' && row.registration_id && row.registration_status !="Declined - Contacted" && row.registration_status !="Not Yet Registered - Contacted" && row.registration_status != "Declined" && row.registration_status != "Not Yet Registered" ? (
                      <div className="as-buttons btn-dropdown-item">
                        <PermissionsGate
                          scopes={['regdelete']}
                          errorProps={{ disabled: true }}
                        >
                          <button
                            onClick={() => {
                              handleDeleteRegistration(row);
                            }}
                            title="Delete Re-registration"
                            className="btn btn-danger rounded-circle"
                          >
                            <i className="fal fa-trash-alt"></i>
                          </button>
                        </PermissionsGate>
                      </div>
                    ) : (
                      <div className="as-buttons btn-dropdown-item">
                        <PermissionsGate
                          scopes={['regadd']}
                          errorProps={{ disabled: true }}
                        >
                          <button
                            onClick={() => {
                              handleAddRegistration(row);
                            }}
                            title="Add Re-registration" 
                            className="btn btn-primary rounded-circle"
                          >
                            <i className="fal fa-plus"></i>                          
                          </button>
                        </PermissionsGate>
                      </div>
                    )}
                      
                    <PermissionsGate
                      scopes={['cprrslmac']}
                      errorProps={{ disabled: true }}
                    >
                      <button
                        className="as-buttons btn btn-primary rounded-circle"
                        title="Mark As Called"
                        onClick={() => {
                          $('#feature-popup').modal('show');
                          setShowCkEditor(true);
                          setStudentID(row);
                        }}
                      >
                        <i style={{ marginRight: '6px' }} className="fal fa-phone"></i>
                      </button>
                    </PermissionsGate>
                  </div>
                </div>
              ) : row.registration_id != '' ? (
                <div className="as-buttons btn-dropdown-item">
                  <PermissionsGate
                    scopes={['regdelete']}
                    errorProps={{ disabled: true }}
                  >
                    <button
                      onClick={() => {
                        handleDeleteRegistration(row);
                      }}
                      title="Delete Re-registration"
                      className="btn btn-danger rounded-circle"
                    >
                      <i className="fal fa-trash-alt"></i>
                    </button>
                  </PermissionsGate>
                </div>
              ) : (
                <div className="as-buttons btn-dropdown-item">
                  <PermissionsGate
                    scopes={['regadd']}
                    errorProps={{ disabled: true }}
                  >
                    <button
                      onClick={() => {
                        handleAddRegistration(row);
                      }}
                      title="Add Re-registration"
                      className="btn btn-primary rounded-circle"
                    >
                      <i className="fal fa-plus"></i>
                    </button>
                  </PermissionsGate>
                </div>
              )}
          </div>
        </div>
      ),
    },
              ]);
              
              
              const exportData = (fileType, fileName) => {
                let data = studentListStatus;
                
                let header = [
                  'Student',
                  'Mobile',
                  'Email',
                  'Re-registration Status',
                  'Decline Reason',
                  'Decline Reason Description',
                  'Student No.',
                  'Student Id',
                  'Programme',
                  'Intake',
                  'Date',
                  'Status',
                  'Sales Rep.',
                ];
                
                data = data?.map((row) => ({
                  ...row,
                  Student: row?.student_name ? row.student_name : '-',
                  Mobile: row?.mobile ? row.mobile : '-',
                  Email: row?.email ? row.email : '-',
                  'Re-registration Status': row?.registration_status
                  ? filterData?.status?.find(
                    (item) => item?.value == row?.registration_status
                  )?.label
                  : row?.registration_status,
                  'Decline Reason': row?.not_submit_reason
                  ? filterData.reason.find((item) => item?.value == row?.not_submit_reason)
                  .label
                  : '-',
                  'Decline Reason Description': row?.not_submit_reason_description
                  ? row?.not_submit_reason_description
                  : '-',
                  'Student No.': row?.student_number ? row.student_number : '-',
                  'Student Id': row?.student_id ? row.student_id : '-',
                  Programme: row?.qualification_name ? row.qualification_name : '-',
                  Intake: row?.intake_year ? row.intake_year + '-' + row.intake_number : '-',
                  Date: row?.created_date
                  ? moment.unix(row.created_date).format(TABLE_DATE_FORMAT) +
                  ' ' +
                  moment.unix(row.created_date).format(TABLE_TIME_FORMAT)
                  : '-',
                  Status: row.status ? row.status : '-',
                  'Sales Rep.': row?.sale_person_first_name
                  ? row?.sale_person_first_name + ' ' + row?.sale_person_last_name
                  : '-',
                }));
                
                if (fileType === 'csv') {
                  const csvString = Papa.unparse({ fields: header, data });
                  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8,' });
                  
                  const blobURL = window.URL.createObjectURL(blob);
                  
                  // Create new tag for download file
                  const anchor = document.createElement('a');
                  anchor.download = fileName;
                  anchor.href = blobURL;
                  anchor.dataset.downloadurl = [
                    'text/csv',
                    anchor.download,
                    anchor.href,
                  ].join(':');
                  anchor.click();
                  
                  // Remove URL.createObjectURL. The browser should not save the reference to the file.
                  setTimeout(() => {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    URL.revokeObjectURL(blobURL);
                  }, 1000);
                } else if (fileType === 'xlsx') {
                  const compatibleData = data?.map((row) => {
                    const obj = {};
                    let test = header?.map((col, index) => {
                      obj[col] = row[col];
                    });
                    return obj;
                  });
                  
                  let wb = XLSX.utils.book_new();
                  let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
                    header,
                  });
                  XLSX.utils.book_append_sheet(wb, ws1, 'React Table Data');
                  XLSX.writeFile(wb, `${fileName}.xlsx`);
                  
                  // Returning false as downloading of file is already taken care of
                  return false;
                }
                if (fileType === 'pdf') {
                  const compatibleData = data?.map((row) => {
                    return [
                      row['Student'],
                      row['Mobile'],
                      row['Email'],
                      row['Re-registration Status'],
                      row['Decline Reason'],
                      row['Decline Reason Description'],
                      row['Student No.'],
                      row['Student Id'],
                      row['Programme'],
                      row['Intake'],
                      row['Date'],
                      row['Status'],
                      row['Sales Rep.'],
                    ];
                  });
                  const doc = new JsPDF();
                  doc.autoTable({
                    head: [header],
                    body: compatibleData,
                    styles: {
                      minCellHeight: 10,
                      minCellWidth: 5,
                      halign: 'left',
                      fontSize: 8,
                    },
                    columnStyles: {
                      0: {
                        columnWidth: 15,
                      },
                      1: {
                        columnWidth: 13,
                      },
                      2: {
                        columnWidth: 24,
                      },
                      3: {
                        columnWidth: 14,
                      },
                      4: {
                        columnWidth: 14,
                      },
                      5: {
                        columnWidth: 14,
                      },
                      6: {
                        columnWidth: 14,
                      },
                      7: {
                        columnWidth: 19,
                      },
                      8: {
                        columnWidth: 12,
                      },
                      9: {
                        columnWidth: 18,
                      },
                      10: {
                        columnWidth: 12,
                      },
                      11: {
                        columnWidth: 15,
                      },
                    },
                  });
                  doc.save(`${fileName}.pdf`);
                  
                  return false;
                }
              };
              
              return (
                <>
                  <DataTableComponent
                    data={studentListStatus}
                    columns={columns}
                    loading={loading}
                    search={debouncedTerm}
                    setSearch={setDebouncedTerm}
                    state={tableState}
                    setState={setTableState}
                    totalRows={totalRows}
                    exportFunction={exportData}
                    exportFileName={"Registration_List"}   
                    tableButton={[
                      <PermissionsGate
                        RenderError={() => (
                          <button className="btn btn-primary" title="Create New" disabled>
                            <i className="fal fa-plus"></i>Create New
                          </button>
                        )}
                        scopes={["pmcpadd"]}
                      >
                        <Link to={`/program-management-center/programmes/programme/add`}>
                          <button className="btn btn-primary" title="Create New">
                            <i className="fal fa-plus"></i>Create New
                          </button>
                        </Link>
                      </PermissionsGate>
                    ]}
                    filters={[
                      {
                        filterName: "Re-registration Status",
                        optionArr: filterData?.status,
                        state: status,
                        setState: setStatus,
                        isOptionReversed: true,
                        uniqueId: "re-reg-status"
                      },
                      {
                        filterName: "Decline Reason",
                        optionArr: filterData?.reason,
                        state: reason ,
                        setState: setReason,
                        isOptionReversed: true,
                        uniqueId: "re-reg-reason",
                        renderLabelFunction: RenderReason
                      },
                      {
                        filterName: "Intake",
                        optionArr: filterData?.intake,
                        state: intake,
                        setState: setIntake,
                        isOptionReversed: true
                      },
                      {
                        filterName: "Sales Rep",
                        optionArr: filterData?.salesRep,
                        state: salesRep ,
                        setState: setSalesRep,
                        isOptionReversed: true
                      },
                      {
                        filterName: "Late Re-Reg",
                        optionArr: filterData?.lateReReg,
                        state: lateReg,
                        setState: setLateReg,
                        isOptionReversed: true,
                        renderLabelFunction: RenderLateReReg
                      }
                    ]}
                  />
                  {showCkEditor && (
                    <div
                    className="topic-add-modal modal fade show"
                    style={{ display: 'block' }}
                    id="feature-popup"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalCenterTitle"
                    aria-hidden="true"
                    >
                    <div
                    className="modal-dialog modal-dialog-centered modal-xl"
                    role="document"
                    >
                    <div className="modal-content modal-border-update">
                    <div className="modal-body p-0">
                    <div className="modal-header modal-header-custom">
                    <h5 className="modal-title">
                    <i className="fal fa-phone"></i> Mark As Called
                    </h5>
                    <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      $('#feature-popup').modal('hide');
                      setShowCkEditor(false);
                      setStudentID('');
                      setContactedNotes('');
                    }}
                    >
                    <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                    <div className="t p-30px">
                    <div className="topic-add-modal-content">
                    <div className="row center-label">
                    <div className="col-md-12">
                    <div className="form-group-blk mb-3">
                    <label>Notes</label>
                    <textarea
                    className={
                      'form-control' + (false ? ' is-invalid' : '')
                    }
                    placeholder="Add Notes"
                    title="Notes"
                    value={contactedNotes}
                    onChange={(e) => setContactedNotes(e.target.value)}
                    rows={3}
                    ></textarea>
                    </div>
                    </div>
                    </div>
                    </div>
                    <div className="form-group form-group-save-cancel mt-3">
                    <button
                    className="btn btn-primary"
                    title="Save"
                    onClick={() => handleConatactedStudent()}
                    disabled={!contactedNotes}
                    >
                    {ContactLoading ? (
                      <i className="fas fa-cog fa-spin"></i>
                    ) : (
                      <i className="fal fa-save"></i>
                    )}
                    Save
                    </button>
                    <button
                    className="btn btn-close btn-danger"
                    type="button"
                    title="Cancel"
                    onClick={() => {
                      $('#feature-popup').modal('hide');
                      setShowCkEditor(false);
                      setStudentID('');
                      setContactedNotes('');
                    }}
                    >
                    <i className="fal fa-times"></i>Cancel
                    </button>
                    </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    </div>
                  )}
                  </>
                );
              };
              
              export default StudentList;
              